import { radiusScale } from "@maeiz/tokens";
import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

export function RadiusPage() {
    return (
        <DocPage
            title="Radius & Borders"
            description="Consistent corner radii and border treatments."
        >
            <Section title="Radius scale">
                <Demo>
                    <div className="flex flex-wrap gap-4">
                        {(Object.keys(radiusScale) as Array<keyof typeof radiusScale>)
                            .filter((k) => k !== "full")
                            .map((k) => (
                                <div key={k} className="text-center">
                                    <div
                                        className="mb-2 h-16 w-16 border-2 border-primary bg-primary/10"
                                        style={{ borderRadius: radiusScale[k] }}
                                    />
                                    <p className="font-mono text-xs">{k}</p>
                                    <p className="font-mono text-[10px] text-neutral-secondary">
                                        {radiusScale[k]}
                                    </p>
                                </div>
                            ))}
                    </div>
                </Demo>
            </Section>
            <Section title="Defaults">
                <SpecTable
                    rows={[
                        ["Controls / buttons", "xl (16px) via rounded-xl / rounded-mz-xl"],
                        ["Cards / panels", "xl–2xl"],
                        ["Badges / chips", "full or md"],
                        ["Borders", "1px solid neutral-border; focus ring 2px primary"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
